jQuery(document).ready(function($) {

	// Intro popup
	// adjust delay accordingly.
	var $homePopup = $("#home-popup");
	if (!$('body').is('.is-admin')) {
		if( Cookies.get('homePopupShown') === undefined) {
			setTimeout(function() {
				if ($homePopup.length > 0) {
					$homePopup.foundation("open");
					Cookies.set('homePopupShown', 'true');
				}
			}, 500);
		}	
	} else {
		// always show popup for admin
		if ($homePopup.length > 0) {
			$homePopup.foundation("open");
		}
	}

})
